import { render } from "./purchase-requisitions.vue?vue&type=template&id=74004ac6&scoped=true"
import script from "./purchase-requisitions.vue?vue&type=script&lang=js"
export * from "./purchase-requisitions.vue?vue&type=script&lang=js"

import "./purchase-requisitions.vue?vue&type=style&index=0&id=74004ac6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74004ac6"]])

export default __exports__